// @flow
import qs from 'query-string';
import { navigate } from '@reach/router';
import { modes, getShortMode, parseShortMode } from './utils';

type SlideState = {
  slide: number,
  mode: $Values<typeof modes>,
  timer: number,
  started: boolean,
  pages: NodeList<HTMLElement>,
};

type SlideAction =
  | {
      type: 'toggle_mode',
      mode: $Values<typeof modes>,
    }
  | { type: 'tick' }
  | { type: 'reset_timer' }
  | { type: 'toggle_timer' }
  | {
      type: 'to',
      to: number,
    }
  | { type: 'prev' }
  | { type: 'next' }
  | {
      type: 'set_pages',
      pages: NodeList<HTMLElement>,
    };

export const initialSlideState: SlideState = {
  slide: 0,
  timer: 0,
  started: false,
  mode:
    typeof window !== 'undefined'
      ? parseShortMode(qs.parse(window.location.search).m) || modes.article
      : modes.article,
  // $FlowFixMe
  pages: [],
};

const slideReducer = (state: SlideState, action: SlideAction) => {
  switch (action.type) {
    case 'to': {
      const { pages } = state;
      if (!pages || !pages.length) {
        return state;
      } else {
        const slideNumber = Math.min(action.to, pages.length - 1);
        return {
          ...state,
          slide: slideNumber,
        };
      }
    }
    case 'prev': {
      const { pages } = state;
      if (!pages || !pages.length) {
        return state;
      }
      const currentHash = window.location.hash
        ? parseInt(window.location.hash.slice(1), 10)
        : 0;
      const slideNumber = Math.max(0, currentHash - 1);
      return {
        ...state,
        slide: slideNumber,
      };
    }
    case 'next': {
      const { pages } = state;
      if (!pages || !pages.length) {
        return state;
      }
      const currentHash = window.location.hash
        ? parseInt(window.location.hash.slice(1), 10)
        : 0;
      const slideNumber = Math.min(pages.length - 1, currentHash + 1);
      return {
        ...state,
        slide: slideNumber,
      };
    }
    case 'toggle_mode': {
      const { search, pathname, hash } = window.location;
      const { mode } = action;
      const currentQuery = qs.parse(search);
      if (mode === state.mode) {
        // mode is equal, set to article
        delete currentQuery.m;
        navigate(`${pathname}${qs.stringify(currentQuery)}${hash}`);
        return {
          ...state,
          mode: modes.article,
        };
      } else {
        const newSearch = qs.stringify({
          ...currentQuery,
          m: getShortMode(mode),
        });
        navigate(`${pathname}?${newSearch}${hash}`);
        return {
          ...state,
          mode: mode,
        };
      }
    }
    case 'tick': {
      return {
        ...state,
        timer: state.timer + 1,
      };
    }
    case 'reset_timer': {
      return {
        ...state,
        timer: 0,
      };
    }
    case 'toggle_timer': {
      return {
        ...state,
        started: !state.started,
      };
    }
    case 'set_pages': {
      return {
        ...state,
        pages: action.pages,
      };
    }
    default:
      throw new Error();
  }
};

export default slideReducer;
